import { createBrowserRouter, RouteObject } from "react-router-dom";
import ButtonPage from "./pages/ButtonPage";
import App from "./App";
import LoadingPage from "./pages/LoadingPage";
import DocsLayout from "./components/DocsLayout";
import MainPage from "./pages/MainPage";
import ComponentsOverviewPage from "./pages/ComponentsOverviewPage";
import DividerPage from "./pages/DividerPage";
import TypographyPage from "./pages/TypographyPage";
import TooltipPage from "./pages/TooltipPage";
import AlertPage from "./pages/AlertPage";
import StepsPage from "./pages/StepsPage";
import SkeletonPage from "./pages/SkeletonPage";
import ModalPage from "./pages/ModalPage";
import PopoverPage from "./pages/PopoverPage";
import DropdownPage from "./pages/DropdownPage";
import EmptyStatePage from "./pages/EmptyStatePage";
import AccordionPage from "./pages/AccordionPage";
import PaginationPage from "./pages/PaginationPage";
import PanelLayoutsPage from "./pages/layouts/PanelLayoutsPage";
import SidebarPage from "./pages/SidebarPage";
import SecureCopyPage from "./pages/SecureCopyPage";
import InputPage from "./pages/form/InputPage";
import SelectPage from "./pages/form/SelectPage";
import TextareaPage from "./pages/form/TextareaPage";
import SwitcherPage from "./pages/form/SwitcherPage";
import CheckboxPage from "./pages/form/CheckboxPage";
import TabsPage from "./pages/TabsPage";
import CardPage from "./pages/CardPage";
import FlexPage from "./pages/FlexPage";
import SimpleTablePage from "./pages/SimpleTablePage";
import DDPPage from "./pages/DDPPage";
import JsonViewerPage from "./pages/JsonViewerPage";
import ThemeChangersPage from "./pages/ThemeChangersPage";
import { overviewPageUrl } from "./urls";
import TabsWithUrlPage from "./pages/TabsWithUrlPage";
import CodeViewerPage from "./pages/CodeViewerPage";
import InstallationPage from "./pages/InstallationPage";
import HooksOverviewPage from "./pages/hooks/HooksOverviewPage";
import UseDjunoDesignPage from "./pages/hooks/UseDjunoDesignPage";
import UseShowPage from "./pages/hooks/UseShowPage";
import UseWindowOnClickPage from "./pages/hooks/UseWindowOnClickPage";
import UtilitiesPage from "./pages/utilities/UtilitiesPage";
import TagPage from "./pages/TagPage";
import FormOverviewPage from "./pages/form/FormOverviewPage";

import BlogsOverviewPage from "./pages/blogs/BlogsOverviewPage";
import CopyablePage from "./pages/blogs/CopyablePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <MainPage />,
      },
      {
        path: "docs",
        element: <DocsLayout />,
        children: [
          { path: "install", element: <InstallationPage /> },
          { path: "ddp", element: <DDPPage /> },
          {
            path: "components",
            children: [
              // { index: true, element: <Navigate to={overviewPageUrl} /> },
              { index: true, element: <ComponentsOverviewPage /> },
              { path: "overview", element: <ComponentsOverviewPage /> },
              { path: "typography", element: <TypographyPage /> },
              { path: "button", element: <ButtonPage /> },
              {
                path: "loading",
                element: <LoadingPage />,
              },
              {
                path: "Divider",
                element: <DividerPage />,
              },
              { path: "tooltip", element: <TooltipPage /> },
              {
                path: "dropdown",
                element: <DropdownPage />,
              },
              { path: "alert", element: <AlertPage /> },
              { path: "steps", element: <StepsPage /> },
              { path: "skeleton", element: <SkeletonPage /> },
              { path: "modal", element: <ModalPage /> },
              { path: "popover", element: <PopoverPage /> },
              { path: "empty-state", element: <EmptyStatePage /> },
              { path: "accordion", element: <AccordionPage /> },
              { path: "pagination", element: <PaginationPage /> },
              { path: "panel-layouts", element: <PanelLayoutsPage /> },
              { path: "sidebar", element: <SidebarPage /> },
              { path: "secure-copy", element: <SecureCopyPage /> },
              {
                path: "form",
                children: [
                  { index: true, element: <FormOverviewPage /> },
                  { path: "input", element: <InputPage /> },
                  { path: "select", element: <SelectPage /> },
                  { path: "textarea", element: <TextareaPage /> },
                  { path: "switcher", element: <SwitcherPage /> },
                  { path: "checkbox", element: <CheckboxPage /> },
                ],
              },
              {
                path: "tabs",

                children: [
                  {
                    index: true,
                    element: <TabsPage />,
                  },
                  {
                    path: "tabs-support-url",
                    element: <TabsWithUrlPage />,
                    children: [
                      { path: "overview", element: "" },
                      { path: "users", element: "" },
                      { path: "setting", element: "" },
                    ],
                  },
                ],
              },

              { path: "card", element: <CardPage /> },
              { path: "flex", element: <FlexPage /> },
              { path: "simple-table", element: <SimpleTablePage /> },
              { path: "json-viewer", element: <JsonViewerPage /> },
              { path: "theme-changers", element: <ThemeChangersPage /> },
              { path: "code-viewer", element: <CodeViewerPage /> },
              { path: "tag", element: <TagPage /> },
            ],
          },
          {
            path: "hooks",
            children: [
              {
                index: true,
                element: <HooksOverviewPage />,
              },
              {
                path: "use-djuno-design",
                element: <UseDjunoDesignPage />,
              },
              {
                path: "use-show",
                element: <UseShowPage />,
              },
              {
                path: "use-window-on-click",
                element: <UseWindowOnClickPage />,
              },
            ],
          },
          {
            path: "utilities",
            element: <UtilitiesPage />,
          },
          {
            path: "blogs",
            children: [
              {
                index: true,
                element: <BlogsOverviewPage />,
              },
              {
                path: "copyable",
                element: <CopyablePage />,
              },
            ],
          },
        ],
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
